import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Order } from "../../../../../services";
import CustomInput from "../../../../custom/custom-input/CustomInput";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import CloseIconNew from "../../../../shared/icons/CloseIconNew";
import style from "./AddProjectNumberModal.module.scss";

const AddProjectNumberModal = ({ isOpen, orderId, onSuccess, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const [referenceNumber, setReferenceNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!referenceNumber) {
      setErrors({ referenceNumber: t("ordersCreate.validation.fillData") });
      return;
    }

    try {
      setIsLoading(true);
      if (onSubmit) {
        await onSubmit(orderId, referenceNumber);
      } else {
        await Order.updateReferenceNumber(orderId, referenceNumber);
      }
      toast.success(t("orderInfo.ordersInfoHeader.projectNumberAdded"));
      setReferenceNumber("");
      setErrors({});
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error updating reference number:", error);
      toast.error(t("common.genericError"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setReferenceNumber("");
    setErrors({});
    if (onCancel) onCancel();
  };

  return ReactDOM.createPortal(
    <div className={style.modalOverlay} data-portal-modal="true">
      <div className={style.modalContainer}>
        <div className={style.topbar}>
          <h2 className={style.modalTitle}>
            {t("orderInfo.ordersInfoHeader.addProjectNumber")}
          </h2>
          <button
            type="button"
            className={style.closeBtn}
            onClick={handleCancel}
            aria-label={t("common.close")}
          >
            <CloseIconNew />
          </button>
        </div>

        <div className={style.card}>
          <CustomInput
            labelText={t("orderInfo.ordersInfoHeader.projectNumber")}
            placeholder={t("orderInfo.ordersInfoHeader.enterProjectNumber")}
            isBgGray
            errorText={!referenceNumber && errors?.referenceNumber}
            inputType="text"
            value={referenceNumber}
            onChangeValue={(item) => {
              setReferenceNumber(item);
              if (item) setErrors({});
            }}
          />
        </div>

        <div className={style.modalActions}>
          <CustomButton
            isCancel
            text={t("common.cancel")}
            onClick={handleCancel}
            disabled={isLoading}
          />
          <CustomButton
            isNavy
            text={t("common.confirm")}
            onClick={handleConfirm}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddProjectNumberModal;
